module.exports = __webpack_public_path__ + "img/google_assistant.d05239ff.png";